<template>
  <div class="study-task-pdf">
    <div class="desc">
      {{ desc }}
    </div>
    <div class="pdf-list">
      <div class="item" v-for="(item, index) in list" :key="index" @click="pageAction(item)">
        <i class="pdf-icon"></i>
        <span class="pdf-name">{{ item.name }}</span>
        <p class="pdf-eye-icon">
          <i></i>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { useRouter } from 'vue-router'
import uitls from '@utils/index'
import app from '@/widget/app'
import { hostPath } from '@utils/basePath'
const props = defineProps({
  desc: {
    type: String,
    default: ""
  },
  list: {
    type: Array,
    default: () => {
      return []
    }
  },
  taskId: {
    type: Number,
    default: 0
  }
})

const $router = useRouter()
const pageAction = (item) => {
  if (uitls.isApp()) {
    app.postMessage({
      type: 'h5',
      url: `${hostPath}/learn/pdf/viewer?url=${window.encodeURIComponent(item.url)}&name=${window.encodeURIComponent(item.name)}`
    })
  } else {
    $router.push(`/pdf/viewer?url=${window.encodeURIComponent(item.url)}&name=${window.encodeURIComponent(item.name)}`)
  }
}

</script>

<style lang="scss" scoped>
.study-task-pdf {
  .desc {
    color: #626366;
    font-size: 28px;
    line-height: 42px;
  }
  .pdf-list {
    margin-top: 30px;
    .item {
      width: 520px;
      height: 100px;
      box-sizing: border-box;
      background-color: #F5F5F7;
      border-radius: 8px;
      display: flex;
      align-items: center;
      padding: 20px 10px;
      margin-bottom: 30px;
      &:last-child {
        margin-bottom: 0;
      }
      .pdf-icon {
        width: 54px;
        height: 62px;
        margin-right: 12px;
        display: inline-block;
        background-image: url("../../img/pdf_icon.png");
        background-size: cover;
        flex-shrink: 0;
      }
      .pdf-name {
        color: #212224;
        font-size: 24px;
        flex: 1;
        height: 68px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .pdf-eye-icon {
        flex-shrink: 0;
        margin-left: 20px;
        margin-right: 20px;
        height: 20px;
        display: flex;
        justify-content: flex-end;
        flex-direction: column;
        i {
          width: 30px;
          height: 20px;
          display: inline-block;
          background-image: url("../../img/pdf_eye_icon.png");
          background-size: cover;
        }
      }
    }
  }
}
</style>
